import React from "react"
import { Link } from "gatsby"

import Layout from "../components/common/layout"
import SEO from "../components/common/seo"

const SuggestPage = ({ data }) => (
  <Layout pageTitle="Suggest a change" enableShare={true}>
    <SEO
      title="Suggest a change or addition | Hive Index"
      description="Help keep Hive Index accurate and up to date. Send corrections, missing details, new topic ideas, or communities we should know about."
      path="/suggest/"
    />

    <div className="relative">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex items-center justify-between">
        <h2 className="pr-3 bg-white text-xl font-medium text-gray-900 flex items-center">
          <div>What you can suggest</div>
        </h2>
      </div>
    </div>
    <p className="mt-2 text-gray-500">
      Help keep Hive Index accurate, useful, and up to date. Send corrections,
      missing details, new topic ideas, or communities we should know about.
    </p>

    <div className="mt-2 text-gray-500">
      <ul className="list-disc pl-6 space-y-1">
        <li>Fix outdated community details</li>
        <li>
          Suggest a missing{" "}
          <Link to="/topics/" className="font-semibold underline">
            topic
          </Link>
        </li>
        <li>
          Recommend a{" "}
          <Link to="/platforms/" className="font-semibold underline">
            community platform
          </Link>{" "}
          we should explore
        </li>
        <li>
          Flag a missing{" "}
          <Link to="/features/" className="font-semibold underline">
            community feature
          </Link>{" "}
          tag
        </li>
        <li>Flag broken links or inaccurate tags</li>
      </ul>
    </div>

    <div className="relative mt-6">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex items-center justify-between">
        <h2 className="pr-3 bg-white text-xl font-medium text-gray-900 flex items-center">
          <div>Suggest a new community</div>
        </h2>
      </div>
    </div>
    <div className="mt-2 text-gray-500">
      If you run the community, use the{" "}
      <Link to="/submit/" className="font-semibold underline">
        submission page
      </Link>{" "}
      so we can collect the right details. If you are just recommending a
      community, email us the URL and a short note about why it belongs on Hive
      Index.
    </div>

    <div className="relative mt-8">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex items-center justify-between">
        <h2 className="pr-3 bg-white text-xl font-medium text-gray-900 flex items-center">
          <div>How to send a suggestion</div>
        </h2>
      </div>
    </div>
    <div className="mt-2 text-gray-500">
      Email{" "}
      <a
        href="mailto:contact@thehiveindex.com?subject=Suggestion"
        className="font-semibold underline text-rose-600"
      >
        contact@thehiveindex.com
      </a>{" "}
      with:
      <ul className="list-disc pl-6 mt-2 space-y-1">
        <li>The Hive Index URL, if there is one</li>
        <li>A short description of the change</li>
        <li>Any source or context that helps us verify it</li>
      </ul>
    </div>
  </Layout>
)

export default SuggestPage
